'use strict';
import { DataModelPropertyDirection } from './enumerations';

function DataModelDescriptor(options) {
	options = options || {};
	var that = this;

	if (!Array.isArray(options.Sources)) {
		throw modelError('`options.Sources` must be Array type');
	}
	if (!Array.isArray(options.Properties)) {
		throw modelError('`options.Properties` must be Array type');
	}
	// If (!Array.isArray(options.ExtraProperties)) {
	//	Throw modelError('`options.ExtraProperties` must be Array type');
	// }

	var sources =
		(options.Sources &&
			options.Sources.map(function (source) {
				return new DataModelSourceDescriptor(source);
			})) ||
		[];

	Object.defineProperty(that, 'Sources', {
		enumerable: true,
		get: function () {
			return sources;
		},
	});

	var properties =
		(options.Properties &&
			options.Properties.map(function (property) {
				return new DataModelPropertyDescriptor(property);
			})) ||
		[];

	Object.defineProperty(that, 'Properties', {
		enumerable: true,
		get: function () {
			return properties;
		},
		set: function (value) {
			if (
				Array.isArray(value) &&
				!value.some(function (valueItem) {
					return !(valueItem instanceof DataModelPropertyDescriptor);
				})
			) {
				properties = value;
			} else {
				throw new Error('Can not set value to `DataModelDescriptor.Properties` - array of `DataModelPropertyDescriptor` objects expected');
			}
		},
	});

	var extraProperties =
		(options.ExtraProperties &&
			options.ExtraProperties.map(function (property) {
				return new DataModelPropertyDescriptor(property);
			})) ||
		[];

	Object.defineProperty(that, 'ExtraProperties', {
		enumerable: true,
		get: function () {
			return extraProperties;
		},
	});
}

DataModelDescriptor.prototype.addSources = function (sourceDescriptors) {
	var model = this;

	if (Array.isArray(sourceDescriptors)) {
		sourceDescriptors.forEach(function (source) {
			if (source instanceof DataModelSourceDescriptor) {
				model.Sources.push(source);
			}
		});
	}
};

DataModelDescriptor.prototype.removeSource = function (path) {
	var model = this;

	if (path) {
		var i = 0;

		if (
			model.Sources.some(function (s) {
				if (s.Path === path) {
					return true;
				}
				i++;
			})
		) {
			model.Sources.splice(i, 1);
			model.Properties = model.Properties.filter(function (prop) {
				return prop.Path.indexOf(path + '.') !== 0;
			});
		}
	}
};

function DataModelSourceDescriptor(options) {
	var that = this;

	options = options || {};

	Object.defineProperty(that, 'Id', {
		writable: true,
		enumerable: true,
		value: options.Id || mx.components.Utils.guid(),
	});

	if (!options.Path) {
		options.Path = options.Name;
	}
	// Mandatory properties
	var requiredProperties = ['Name', 'Path'];

	var notPassed = [];

	requiredProperties.forEach(function (propertyName) {
		if (!options.hasOwnProperty(propertyName) && !options[propertyName]) {
			notPassed.push(propertyName);
		} else {
			Object.defineProperty(that, propertyName, {
				writable: true,
				enumerable: true,
				value: options[propertyName],
			});
		}
	});

	if (notPassed.length) {
		throw sourceError('required options not passed: ' + notPassed.join(', '));
	}

	if (options.StaticSource !== true) {
		// Safe inittialization of EntityName, DataQueryId or OperationId - one of them must be presented
		requiredProperties = ['EntityName', 'DataQueryId', 'OperationId', 'DataDefinition', 'WorkflowId'];
		var presented = requiredProperties.filter(function (propertyName) {
			return options.hasOwnProperty(propertyName) && options[propertyName];
		});

		if (presented.length === 0) {
			throw sourceError('one of these options must to be passed: ' + requiredProperties.join(', '));
		}

		if (presented.length > 1) {
			throw sourceError('only one of these options need to be presented: ' + requiredProperties.join(', ') + '; but passed: ' + presented.join(', '));
		}

		if (options.EntityName) {
			Object.defineProperty(that, 'EntityName', {
				writable: true,
				enumerable: true,
				value: options.EntityName,
			});
		} else if (options.DataDefinition) {
			Object.defineProperty(that, 'DataDefinition', {
				writable: true,
				enumerable: true,
				value: options.DataDefinition,
			});
			Object.defineProperty(that, 'IsArray', {
				writable: true,
				enumerable: true,
				value: options.IsArray,
			});
			Object.defineProperty(that, 'Filter', {
				writable: true,
				enumerable: true,
				value: options.Filter,
			});
			Object.defineProperty(that, 'FilterExpression', {
				writable: true,
				enumerable: true,
				value: options.FilterExpression,
			});
			Object.defineProperty(that, 'AllowUnsafeFilter', {
				writable: true,
				enumerable: true,
				value: options.AllowUnsafeFilter,
			});
			Object.defineProperty(that, 'MultiCurrencies', {
				writable: true,
				enumerable: true,
				value: options.MultiCurrencies,
			});
		} else if (options.DataQueryId) {
			Object.defineProperty(that, 'DataQueryId', {
				writable: true,
				enumerable: true,
				value: options.DataQueryId,
			});
			Object.defineProperty(that, 'FilterExpression', {
				writable: true,
				enumerable: true,
				value: options.FilterExpression,
			});
			Object.defineProperty(that, 'AllowUnsafeFilter', {
				writable: true,
				enumerable: true,
				value: options.AllowUnsafeFilter,
			});
		} else if (options.OperationId || options.WorkflowId) {
			Object.defineProperty(that, 'OperationId', {
				writable: true,
				enumerable: true,
				value: options.OperationId,
			});

			Object.defineProperty(that, 'WorkflowId', {
				writable: true,
				enumerable: true,
				value: options.WorkflowId,
			});

			Object.defineProperty(that, 'RelativePath', {
				writable: true,
				enumerable: true,
				value: options.RelativePath,
			});

			Object.defineProperty(that, 'RouteTemplate', {
				writable: true,
				enumerable: true,
				value: options.RouteTemplate,
			});

			Object.defineProperty(that, 'ServiceType', {
				writable: true,
				enumerable: true,
				value: options.ServiceType,
			});

			Object.defineProperty(that, 'BaseUrl', {
				writable: true,
				enumerable: true,
				value: options.BaseUrl,
			});
		}

		Object.defineProperty(that, 'HttpMethod', {
			writable: true,
			enumerable: true,
			value: options.HttpMethod || 1,
		});

		Object.defineProperty(that, 'Direction', {
			writable: true,
			enumerable: true,
			value: options.Direction || 0,
		});

		Object.defineProperty(that, 'Reloadable', {
			writable: true,
			enumerable: true,
			value: options.Reloadable === true,
		});

		Object.defineProperty(that, 'RefreshInterval', {
			writable: true,
			enumerable: true,
			value: Number(options.RefreshInterval),
		});

		Object.defineProperty(that, 'RewriteResponse', {
			writable: true,
			enumerable: true,
			value: options.RewriteResponse === true,
		});

		Object.defineProperty(that, 'LoadOnInit', {
			writable: true,
			enumerable: true,
			value: options.LoadOnInit === true,
		});

		Object.defineProperty(that, 'OnSaving', {
			writable: true,
			enumerable: true,
			value: options.OnSaving === true,
		});

		Object.defineProperty(that, 'OnSaved', {
			writable: true,
			enumerable: true,
			value: options.OnSaved === true,
		});

		Object.defineProperty(that, 'Download', {
			writable: true,
			enumerable: true,
			value: options.Download === true,
		});
	}
}

function DataModelPropertyDescriptor(options) {
	if (typeof options !== 'object' || options === null) {
		throw propertyError('`options` argument is not passed or it is empty');
	}
	var that = this;

	Object.defineProperty(that, 'Name', {
		writable: true,
		enumerable: true,
		value: options.Name,
	});

	Object.defineProperty(that, 'Title', {
		writable: true,
		enumerable: true,
		value: options.Title,
	});

	Object.defineProperty(that, 'ReferenceName', {
		writable: true,
		enumerable: true,
		value: options.ReferenceName,
	});
	Object.defineProperty(that, 'SystemType', {
		writable: true,
		enumerable: true,
		value: options.SystemType,
	});
	Object.defineProperty(that, 'Type', {
		writable: true,
		enumerable: true,
		value: options.Type,
	});
	Object.defineProperty(that, 'IsArray', {
		writable: true,
		enumerable: true,
		value: options.IsArray || options.isArray || false,
	});
	Object.defineProperty(that, 'Value', {
		writable: true,
		enumerable: true,
		value: options.Value || '',
	});
	Object.defineProperty(that, 'Expression', {
		writable: true,
		enumerable: true,
		value: options.Expression || '',
	});
	Object.defineProperty(that, 'Parameters', {
		writable: true,
		enumerable: true,
		value: options.Parameters || [],
	});
	Object.defineProperty(that, 'Direction', {
		writable: true,
		enumerable: true,
		value: options.Direction || DataModelPropertyDirection.NONE,
	});
	Object.defineProperty(that, 'ParentPath', {
		writable: true,
		enumerable: true,
		value: options.ParentPath || '',
	});
	Object.defineProperty(that, 'ParentItem', {
		writable: true,
		enumerable: false, // not to store in server DB
		value: options.ParentItem,
	});
	Object.defineProperty(that, 'Path', {
		writable: true,
		enumerable: true,
		value: options.Path || '',
	});

	Object.defineProperty(that, 'EditMode', {
		writable: true,
		enumerable: true,
		value: options.EditMode || 1,
	});
}

function mxDataModelError(msg) {
	return new Error('Data Model Exception: ' + msg);
}

function mxDataModelErrorOnInit(type, msg) {
	return mxDataModelError('can not initialize `' + type + '` - ' + msg);
}

var modelError = mxDataModelErrorOnInit.bind(null, 'DataModelDescriptor');
var sourceError = mxDataModelErrorOnInit.bind(null, 'DataModelSourceDescriptor');
var propertyError = mxDataModelErrorOnInit.bind(null, 'DataModelPropertyDescriptor');

export { DataModelDescriptor, DataModelSourceDescriptor, DataModelPropertyDescriptor };
